import React from "react";
import { UnitStatus, unitStatusTitle } from "./unit-status";
import styles from "./UnitStatusMark.module.scss";

const SYMBOLS: Record<UnitStatus, string> = {
    missing: "!",
    unsigned: "",
    signed: "✓",
};

/** Кружок состояния раздела: красный — нет файлов, голубой — не подписан, зелёный — подписан */
export const UnitStatusMark = ({ status }: { status: UnitStatus }) => (
    <span className={`${styles.mark} ${styles[status]}`} title={unitStatusTitle[status]}>
        {SYMBOLS[status]}
    </span>
);

/** Кружки категории: сколько разделов без файлов и сколько не подписано; всё подписано — зелёный */
export const CategoryStatusMarks = ({ statuses }: { statuses: UnitStatus[] }) => {
    const missing = statuses.filter((s) => s === "missing").length;
    const unsigned = statuses.filter((s) => s === "unsigned").length;
    const stop = (e: React.MouseEvent) => e.stopPropagation();

    if (!statuses.length) {
        return null;
    }

    return (
        <span className={styles.marks} onClick={stop}>
            {missing > 0 && (
                <span
                    className={`${styles.mark} ${styles.missing}`}
                    title={`Без результата работ: ${missing}. Проект не перевести в Завершение`}
                >
                    {missing}
                </span>
            )}
            {unsigned > 0 && (
                <span className={`${styles.mark} ${styles.unsigned}`} title={`Не подписано: ${unsigned}`}>
                    {unsigned}
                </span>
            )}
            {!missing && !unsigned && <UnitStatusMark status="signed" />}
        </span>
    );
};
